<template>
  <v-layout row class="and-or-rule" pl-3>
    <v-flex xs4>
      <v-select
        class="form-control input-sm no-underline"
        v-model="key"
        :items="options.keys"
        item-text="name"
        placeholder="Select Field"
      />
    </v-flex>

    <v-flex xs2>
      <v-select
        class="form-control input-sm no-underline"
        v-model="operator"
        placeholder="Operator"
        :items="options.operators"
        item-text="name"
      />
    </v-flex>

    <v-flex xs5>
      <v-text-field
        type="text"
        class="form-control input-sm no-underline"
        v-model="value"
        placeholder="123"
      />
    </v-flex>

    <v-flex pr-3>
      <v-checkbox label="Show"/> 
    </v-flex>

    <v-flex class="action-col" pt-2>
      <div class="text-xs-center">
        <div>
          <v-btn color="error" fab small dark @click="deleteSelf()">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "rule",
  props: ["options"],
  watch: {
    "options.keys.options"() {
      this.key = -99;
    },
    "options.conditions.options"() {
      this.condition = -99;
    }
  },
  data() {
    return {
      key: -99,
      operator: -99,
      value: ""
    };
  },
  methods: {
    deleteSelf() {
      this.$emit("delete-rule");
    },
    queryFormStatus() {
      return {
        key: this.key,
        operator: this.operator,
        value: this.value
      };
    },
    fillRuleStatus(data) {
      this.key = data.key;
      this.operator = data.operator;
      this.value = data.value;
    }
  }
};
</script>

<style lang="scss">
.action-col {
  max-width: 50px;
  min-width: 50px;
}
</style>